<template>
    <b-tab :title="langTabTitle">
        <b-form-group>
            <b-row>
            

                <b-form-group class="col-md-6" label-for="edit_form_backend_options">
                    <template v-slot:label>
                        <h5 key="lang_form_backend_options">Scheduling Options</h5>
                    </template>
                    <template v-slot:description>
                        <h6 key="lang_form_backend_options_desc">Control how this playlist is handled.</h6>
                    </template>

                    <b-form-checkbox-group stacked id="edit_form_backend_options" v-model="form.backend_options.$model">
                        <b-form-checkbox value="interrupt">
                            <h6 key="lang_backend_option_interrupt">Interrupt other songs to play at scheduled time.</h6>
                        </b-form-checkbox>
                        <b-form-checkbox value="loop_once">
                            <h6 key="lang_backend_option_loop_once">Only loop through playlist once.</h6>
                        </b-form-checkbox>
                        <b-form-checkbox value="single_track">
                            <h6 key="lang_backend_option_single_track">Only play one track at scheduled time.</h6>
                        </b-form-checkbox>
                        <b-form-checkbox value="merge">
                            <h6 key="lang_backend_option_merge">Merge playlist to play as a single track.</h6>
                        </b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-row>
        </b-form-group>
    </b-tab>
</template>

<script>
export default {
    name: 'PlaylistEditAdvanced',
    props: {
        form: Object
    },
    computed: {
        langTabTitle () {
            return 'More';
        }
    }
};
</script>
